const aiChatBox = {
  init() {
    aiChatBox.create();
  },
  create() {
    const taliaChat = $("[data-talia-chat]");

    if (taliaChat.length) {
      setInterval(function () {
        taliaChat.removeClass("animated");
      }, 1000);

      setInterval(function () {
        taliaChat.addClass("animated");
      }, 4000);
    }

    $(document).on("click", "[data-talia-chat]", function () {
      const self = $(this);
      const aiChatBox = $("#chatai-widget-container");

      if (aiChatBox.length) {
        if (
          self.hasClass("display-with-smart-suggestions") &&
          !aiChatBox.hasClass("display-with-smart-suggestions")
        ) {
          aiChatBox.addClass("display-with-smart-suggestions");
        }

        if (self.hasClass("clicked")) {
          $('[data-talia-chat]').removeClass("clicked");
          aiChatBox.stop().fadeOut();
        } else {
          $('[data-talia-chat]').addClass("clicked");
          aiChatBox.stop().fadeIn();
        }
      }
    });

    $(document).on(
      "click",
      ".chatai-widget-conversation-header-close-icon",
      function () {
        const cta = $("[data-talia-chat].clicked");
        if (cta.length) {
          cta.trigger("click");
        }
      }
    );
  },
};

document.addEventListener("DOMContentLoaded", () => {
  aiChatBox.init();
});
